"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t={display:"flex",alignItems:"center",textWrap:"nowrap"};exports.ctaButton=t;
